import { useState } from "react";
import "./WazawanReportingPreview.css";
import { Maximize2 } from "lucide-react";
import { PromptPair } from "./Wazawan";
import { DCReporting } from "../app/dynamic-components/DCReporting";

type WazawanReportingPreviewProps = {
    promptPair: PromptPair;
    onExpand: (promptPair: PromptPair) => void;
}

export const WazawanReportingPreview = ({promptPair, onExpand} : WazawanReportingPreviewProps) => {

    let response: any = null;

    try {
        response = JSON.parse(promptPair.response);
    } catch (e) {
        response = promptPair.response;
    }

    console.log("[WazawanReportingPreview] promptPair.response: ", promptPair.response);
    
    return (
        <div className="wazawan-reporting-preview">
            <DCReporting 
                data={response.data} 
                isPreview={true}
            />
            <div 
                className="wazawan-reporting-preview-expand"
                onClick={()=>onExpand(promptPair)}
            >
                <Maximize2 size={16}/>
            </div>
        </div>        
    )
}